// extracted by mini-css-extract-plugin
module.exports = {"card":"CardOefening-module--card--16iFW","wrapper":"CardOefening-module--wrapper--XbFAC"};